<template functional>
    <div id="show-tab-topics">
        <div class="tw-flex tw-justify-between tw-items-center tw-mt-2 tw-px-2 tw-mb-5 tw-pb-2 tw-border-b tw-border-gray-100 tw-z-10 tw-relative">
            <p class="tw-text-xs tw-font-semibold light-text">
                {{ props.recent_posts_trans_key }}
            </p>
            <displaymode></displaymode>
        </div>

        <newpost :board_id_prop="props.channelId" v-if="!props.impersonating"></newpost>

        <feed :board_id_prop="props.channelId" key="group_event_feed_newest"></feed>
    </div>
</template>

<script>
    export default {
        name: 'GroupsAndEventsTabTopics',

        props: {
            channelId: {
                required: true,
            },
            recent_posts_trans_key: {
                default: '',
                required: true,
            },
            impersonating: {
                required: true,
                default: false,
            },
        },
    };
</script>

<style lang="scss">
    #show-tab-topics {
        .feed-display-switch-compact {
            @apply tw-mr-3;
        }
    }
</style>
